import { useEffect, useRef } from 'react';

export const useOnceWhenOpen = (isOpen: boolean, callback: () => void) => {
  const hasRunRef = useRef(false);

  useEffect(() => {
    if (isOpen && !hasRunRef.current) {
      hasRunRef.current = true;
      callback();
    }
  }, [isOpen, callback]);
};
